<div class="content">
    <div>
        <div style="text-align: center;"><img title="Error" alt="Error" src="assets/images/logo.png" height="75"></div>
        <div class="header">Oops! We have encountered an error.</div>
        <div class="detail">{{ message }}</div>
    </div>
</div>
